import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Field } from "formik";
import Yup from "yup";
import { CustomInput, ErrorField } from 'components/form';
import { Clear } from 'components';
import { loginWorker } from 'ducks/auth/actions';
import { user as userType } from 'api/users/types';
import { safe } from 'utilities';
import logo from 'assets/images/im_logo2.png';
import logo2 from 'assets/images/logo2.svg';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
    })
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      next: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string
      })
    })
  }).isRequired,
  history: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  auth: userType,
};

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.initialData = {
      email: "",
      password: "",
    };

    this.validationSchema = Yup.object().shape({
      email: Yup.string().required('To pole jest wymagane'),
      password: Yup.string().required('To pole jest wymagane'),
    })
  }

  componentDidUpdate(oldProps) {
    const { history, location, auth } = this.props;
    if(auth && auth !== oldProps.auth) {
      history.push(safe(location, 'state.next') || '/');
    }
  }

  handleSubmit = async (values, { setErrors, setSubmitting }) => {
    try {
      await this.props.login(values);
    } catch({ error }) {
      setErrors(error);
      setSubmitting(false);
    }
  }

  render() {

    return (
      <Formik
        initialValues={this.initialData}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ errors, handleSubmit, isSubmitting }) => (
          <div className="body login-page-wrapper">
            <div className="image-container">
              <div className="im-logo-container"><img src={logo} alt=""/>
              </div>
            </div>
            <div className="form-container">
              <div className="form-container-inner">
                <div className="form-heading" style={{ marginBottom: 43 }}>
                  <h3>Panel logowania</h3>
                  <h5>Meble lepsze niż dobre</h5>
                </div>
                <ErrorField text={errors.message} />
                <Clear height={20} />
                <form action="#" onSubmit={handleSubmit} noValidate={true}>
                  <Field name="email" label="email" type="email" component={CustomInput} autoFocus />
                  <Field name="password" type="password" label="hasło" component={CustomInput} />
                  <div className="btn-container nomargin">
                    <button className="full-btn" type="submit" disabled={isSubmitting}>
                      Zaloguj się
                    </button>
                    <Link to="/password/reset" className="reset-link">
                      Nie pamiętasz hasła?
                    </Link>
                  </div>
                </form>
              </div>
              <div className="copyrights">
                  <a href="https://kivy.pl/" >
                      <span className="copyrights-text">Created by</span>
                      <span className="kivy-logo"><img src={logo2} alt=""/></span>
                  </a>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapState = state => ({
  auth: state.auth.user,
});

const mapDispatch = {
  login: loginWorker,
};

Login.propTypes = propTypes;
const enhance = compose(
  connect(mapState, mapDispatch),
);

export default enhance(Login);


// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx